<template>
  <div class="smart-engine-wrapper">
    <h1>Review Prior Authorization</h1>
    <div class="shadow-ellipse shadow-ellipse-right"></div>
    <div class="shadow-ellipse shadow-ellipse-left"></div>
    <GreenCirclePreloader v-if="showPreloader" />
    <template v-if="!showPreloader && orderInfo.orderKey">
      <v-alert v-if="priorAuthHidden" type="info" variant="tonal" class="mb-4">{{ PA_NOT_SUBMITTING_NOTICE }}</v-alert>
      <AllFormStepsView :address-books="addressBooks" :submit-hidden="priorAuthHidden" />
    </template>
    <div v-if="errors.length > 0" class="error-container">
      <h2>Looks like you can't access this Prior Authorization</h2>
    </div>
  </div>
</template>

<script setup>
import { useMarkCaseOpened } from "@/composables/useCaseReadState";
import AllFormStepsView from "@/pages/AllFormStepsView";
import GreenCirclePreloader from "@/components/GreenCirclePreloader";

import { ref, onMounted, onUnmounted } from "vue";
import { storeToRefs } from "pinia";
import { useOrderInfoStore } from "@/stores";
import { orderInfoService } from "@/services/orderInfoService";
import { useRoute } from "vue-router";
import { clearOrderInfoStorage } from "@/utils";
import { tryParseApiErrors } from "@/utils";
import { PA_NOT_SUBMITTING_NOTICE, useOrderPriorAuthHidden } from "@/composables/usePriorAuthHidden";

const errors = ref([]);
const route = useRoute();
useMarkCaseOpened("orderKey", () => route.params.id);
const showPreloader = ref(false);
const addressBooks = ref(null);
const { orderInfo } = storeToRefs(useOrderInfoStore());
const priorAuthHidden = useOrderPriorAuthHidden(orderInfo);

onMounted(() => {
  if (route.params.id) {
    getOrderDetails(route.params.id);
  }
});

onUnmounted(() => {
  clearOrderInfoStorage();
});

async function getOrderDetails(id) {
  showPreloader.value = true;
  try {
    const order = await orderInfoService.getOrderDetails(id);
    addressBooks.value = await orderInfoService.getAvailableAddressBooks();
    orderInfo.value = order.orderInfo;
  } catch (err) {
    errors.value = tryParseApiErrors(err);
  }
  showPreloader.value = false;
}
</script>

<style lang="scss" scoped>
@import "../styles/pages/_smart-engine-container.scss";
</style>
